<template>
  <div>
    <span v-if="field.type === fieldType.TABLE">
      {{ field.name }}
      <ul>
        <li v-for="(subField, index) in field['sub-fields']" :key="index" >
          <span v-if="subField.type === fieldType.MULTIPLE" >{{ subField.name }} - <b>{{ "${f" + field.order + "_" + subField.order + "@1}" }}</b>, <b>{{ "${f" + field.order + "_" + subField.order + "@2}" }}</b>...</span>
          <span v-else >{{ subField.name }} - <b>{{ "${f" + field.order + "_" + subField.order + "}" }}</b></span>
        </li>
      </ul>
    </span>
    <span v-else-if="field.type === fieldType.MULTIPLE" >{{ field.name }} - <b>{{ "${f" + field.order + "@1}" }}</b>, <b>{{ "${f" + field.order + "@2}" }}</b>...</span>
    <span v-else >{{ field.name }} - <b>{{ "${f" + field.order + "}" }}</b></span>
  </div>
</template>

<script>
import fieldType from '@/enums/fieldType'

export default {
  props: ['field'],
  computed: {
    fieldType() {
      return fieldType
    }
  },
}
</script>

<style>
</style>
